import * as React from 'react';
import { DosageLevelModel } from "../../../models/dosageLevelModel";
import { groupByReturnArray } from '../../../common/functions/helperFunctions';
import { DosageContentModel } from "../../../models/dosageContentModel";
import MedicineService from '../../../services/medicineService';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import { sprintf } from 'sprintf-js';
import { connect } from 'react-redux';

interface IProps {
  medicineId: any,
  lang: string
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  dosageContent: DosageContentModel | null;
}

class dosageTab extends React.Component<IProps, IState> {
  medicineService = new MedicineService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      dosageContent: null
    };
  }

  componentDidMount() {
    this.getDosageContent();
  }

  getDosageContent = () => {
    this.setState({
      isLoading: true
    });

    this.medicineService.getDosageContent(this.state.medicineId, this.props.lang).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          dosageContent: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  public render() {
    const { medicineId, isLoading, error } = this.state;

    var dosageContent: DosageContentModel | null;
    if (this.state.dosageContent) {
      dosageContent = this.state.dosageContent;
    } else {
      dosageContent = null;
    }

    let dosageElement: any = null;
    let dosageDescrContent: any = null;
    let dosageDataList: Array<any> | null = [];

    if (dosageContent) {
      dosageDescrContent =
        <>
          {dosageContent.summary ? <div dangerouslySetInnerHTML={{ __html: dosageContent.summary }}></div> : null}
          {dosageContent.overdoseDescription ?
            <>
              <h4>{Translate('Overdose Description')}</h4>
              <div style={{ marginBottom: "30px" }} dangerouslySetInnerHTML={{ __html: dosageContent.overdoseDescription }}></div>
            </> : null}
          {dosageContent.doseAdjustments ?
            <>
              <h4>{Translate('Dose Adjustments')}</h4>
              <div style={{ marginBottom: "30px" }} dangerouslySetInnerHTML={{ __html: dosageContent.doseAdjustments }}></div>
            </> : null}
          {dosageContent.precautions ?
            <>
              <h4>{Translate('Precautions')}</h4>
              <div style={{ marginBottom: "30px" }} dangerouslySetInnerHTML={{ __html: dosageContent.precautions }}></div>
            </> : null}
          {/* {dosageContent.otherComments ?
            <>
              <h4>{Translate('Other Comments')}</h4>
              <div style={{ marginBottom: "30px" }} dangerouslySetInnerHTML={{ __html: dosageContent.otherComments }}></div>
            </> : null}
          {dosageContent.otherInformation ?
            <>
              <h4>{Translate('Other Information')}</h4>
              <div style={{ marginBottom: "30px" }} dangerouslySetInnerHTML={{ __html: dosageContent.otherInformation }}></div>
            </> : null} */}
        </>;

      if (dosageContent.dosageLevels && dosageContent.dosageLevels.length > 0) {
        var groupedByAge = groupByReturnArray(dosageContent.dosageLevels, 'ageGroupId');
        for (var i = 0; i < groupedByAge.length; i++) {
          var ageGroup = groupedByAge[i];

          if (ageGroup) {
            var diseaseGroups = groupByReturnArray(ageGroup, 'diseaseId');

            for (var j = 0; j < diseaseGroups.length; j++) {

              var diseaseGroup: Array<DosageLevelModel> = diseaseGroups[j];
              var currentGroup: any = {};
              var currentDiseaseGroup: any = {};
              var currentGroupTitle: any = {};
              var currentGroupFooter: any = {};

              if (diseaseGroup) {
                currentGroupTitle =
                  <p key={'t' + i + j} style={{ fontSize: 20, marginBottom: "10px" }}>
                    <strong>
                      {Translate(diseaseGroup[0].ageGroup.ageGroupName)} - {Translate('usual dose for')}&nbsp;
                      {diseaseGroup[0].disease.diseaseName}
                    </strong>
                  </p>;
                currentGroupFooter =
                  <div key={'f' + i + j}>
                    {diseaseGroup[0].comments ? <div>{Translate('Comments')}: {diseaseGroup[0].comments}</div> : ''}
                    {diseaseGroup[0].uses ? <div>{Translate('Uses')}: {diseaseGroup[0].uses}</div> : ''}
                  </div>
                currentDiseaseGroup = diseaseGroup.map(m =>
                  <div key={m.dosageLevelId}>
                    <div style={{ marginBottom: "0px" }}><strong>{Translate(m.roaType.roatypeDescr)}: </strong></div>
                    <div style={{ marginBottom: "0px" }}>{m.singleDose} {m.minMaxTimeBetweenIntakes}</div>
                    {m.maxDailyDose ? <div style={{ marginBottom: "0px" }}>{Translate('Maximum dose')}: {m.maxDailyDose}</div> : ''}
                    {m.minMaxTitration ? <div>{Translate('Duration of therapy')}: {m.minMaxTitration}</div> : ''}
                    {//Comment groupFooter and uncomment this, if comments and uses needed for each route of administration type
                    /* {m.comments ? <p>Comments: {m.comments}</p> : <p></p>}
                  {m.uses ? <p>Uses: {m.uses}</p> : <p></p>} */}
                  </div>
                )
              } else {
                continue;
              }
              currentGroup =
                <div style={{ marginBottom: "30px" }} key={currentGroupTitle.key}>
                  {currentGroupTitle}
                  {currentDiseaseGroup}
                  {currentGroupFooter}
                </div>

              dosageDataList.push(currentGroup);
            }
          } else {
            continue;
          }
        }
      } else {
        dosageDataList = null;
      }
    }

    dosageElement =
      <div>
        {dosageDescrContent}
        {dosageDataList}
      </div>

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
        {dosageElement}
      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(dosageTab);
